<template>
  <teleport to="body">
    <div
      v-if="isMeetingOpen"
      class="hs-meeting-dialog"
      @click.self="closeMeeting"
    >
      <div class="hs-meeting-dialog__window">
        <button
          type="button"
          class="hs-meeting-dialog__close"
          aria-label="Close"
          @click="closeMeeting"
        >
          &times;
        </button>
        <hub-spot-meeting
          :meeting-url="brand.meeting.url"
          :booking-source="bookingSource"
          title="Schedule a meeting"
        />
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import HubSpotMeeting from '@/components/ui/HubSpotMeeting.vue';
import { useMeeting } from '@/composables/useMeeting';
import { useBrand } from '@/brands';

const brand = useBrand();
const { isMeetingOpen, bookingSource, closeMeeting } = useMeeting();
</script>

<style lang="scss" scoped>
.hs-meeting-dialog {
  position: fixed;
  inset: 0;
  z-index: 100000;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;

  // Ширина ≥750px внутри iframe включает широкую двухколоночную раскладку
  // виджета; на мобиле занимает всю ширину (виджету нужно ≥320px).
  &__window {
    position: relative;
    width: 100%;
    max-width: 900px;
    max-height: 90vh;
    overflow-y: auto;
    background: #fff;
    border-radius: 12px;
    padding: 32px 16px 16px;

    @media (max-width: 767px) {
      padding: 32px 4px 4px;
    }
  }

  &__close {
    position: absolute;
    top: 4px;
    right: 8px;
    border: 0;
    background: none;
    font-size: 28px;
    line-height: 1;
    cursor: pointer;
    color: #777e8b;
    z-index: 2;

    &:hover {
      color: #000;
    }
  }
}
</style>
